(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pretty-customers"]) return;
  try {
    
if (!customElements.get('pretty-customer-gallery')) {
  customElements.define('pretty-customer-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const photo = dialog.querySelector('img');
      let trigger;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.pcg-photo-open');
        if (button) {
          trigger = button;
          photo.src = button.dataset.full;
          photo.alt = button.dataset.alt;
          dialog.showModal();
        }
        if (event.target.closest('.pcg-close') || event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => { if (trigger) trigger.focus({preventScroll:true}); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pretty-finance"]) return;
  try {
    
if(!customElements.get('pretty-finance'))customElements.define('pretty-finance',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'});const budget=this.querySelector('[data-budget]'),deposit=this.querySelector('[data-deposit]'),rate=this.querySelector('[data-apr]');
const update=()=>{const amount=Number(budget.value);budget.style.setProperty("--pf-budget-progress",((amount-Number(budget.min))/(Number(budget.max)-Number(budget.min))*100)+"%");const down=Math.min(amount,Math.max(0,Number(deposit.value)||0));deposit.max=String(amount);if(Number(deposit.value)>amount)deposit.value=String(amount);const apr=Math.min(99,Math.max(0,Number(rate.value)||0));const months=Number(this.querySelector('.pf-terms input:checked').value);const financed=amount-down;const monthlyRate=Math.pow(1+apr/100,1/12)-1;const monthly=monthlyRate===0?financed/months:financed*monthlyRate/(1-Math.pow(1+monthlyRate,-months));const total=down+monthly*months;const interest=Math.max(0,total-amount);const put=(key,value)=>this.querySelector('[data-'+key+']').textContent=value;
put('budget-label',money.format(amount));put('payment',money.format(monthly));put('schedule',months+' monthly payments after a '+money.format(down)+' deposit');put('deposit-total',money.format(down));put('financed',money.format(financed));put('interest',money.format(interest));put('total',money.format(total));
this.querySelector('[data-deposit-bar]').style.width=(down/total*100)+'%';this.querySelector('[data-finance-bar]').style.width=(financed/total*100)+'%';this.querySelector('[data-interest-bar]').style.width=(interest/total*100)+'%';};
this.addEventListener('input',update);this.addEventListener('change',update);update();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pretty-product-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialise = (root) => {
  if (root.dataset.initialised) return;
  root.dataset.initialised = 'true';
  const nav = root.querySelector('.pretty-faq__nav');
  const groups = [...root.querySelectorAll('[data-group]')];
  const buttons = [...nav.querySelectorAll('button')];
  const show = value => {
   groups.forEach(group => { group.hidden = group.dataset.group !== value; });
   buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === value)));
  };
  if (!buttons.length) return;
  root.classList.add('is-ready'); nav.hidden = false;
  buttons.forEach(button => button.addEventListener('click', () => show(button.dataset.category)));
  root.addEventListener('shopify:block:select', event => {
   const group = event.target.closest('[data-group]');
   if (group) { show(group.dataset.group); const item = event.target.closest('details'); if (item) item.open = true; }
  });
  show(buttons[0].dataset.category);
 };
 const scan = () => document.querySelectorAll('.pretty-faq').forEach(initialise);
 scan(); document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pretty-stock-variants"]) return;
  try {
    
if(!customElements.get('pretty-stock-variants')){
 customElements.define('pretty-stock-variants',class extends HTMLElement{
  connectedCallback(){
   if(this.dataset.ready)return;
   this.dataset.ready='true';
   this.cards=Array.from(this.querySelectorAll('.psv-card'));
   this.groups=Array.from(this.querySelectorAll('[data-stock-group]'));
   this.controls=Object.fromEntries(Array.from(this.querySelectorAll('[data-filter]')).map(el=>[el.dataset.filter,el]));
   this.status=this.querySelector('.psv-status');
   this.complete=!this.dataset.next;
   this.rebuild();this.restore();this.update();
   this.querySelector('.psv-toolbar').hidden=false;
   this.querySelector('.psv-jumps').hidden=false;
   if(matchMedia('(max-width:767px)').matches)this.querySelector('details').open=false;
   this.querySelectorAll('[data-filter]').forEach(el=>el.addEventListener('input',()=>{this.save();this.update()}));
   this.querySelector('.psv-clear').addEventListener('click',()=>{Object.values(this.controls).forEach(el=>el.value=el.dataset.filter==='sort'?'featured':'');this.save();this.update()});
   this.pop=()=>{this.restore();this.update()};window.addEventListener('popstate',this.pop);
   this.loadRemaining();
  }
  disconnectedCallback(){window.removeEventListener('popstate',this.pop);this.abort?.abort()}
  rebuild(){
   const selected=this.controls.colour.value;
   this.controls.colour.querySelectorAll('option:not(:first-child)').forEach(x=>x.remove());
   [...new Set(this.cards.map(c=>c.dataset.colour).filter(Boolean))].sort().forEach(value=>this.controls.colour.add(new Option(value,value)));
   this.controls.colour.value=selected;
   this.controls.group.querySelectorAll('option:not(:first-child)').forEach(x=>x.remove());
   this.groups.forEach(group=>{
    const key=group.dataset.stockGroup;
    if(this.cards.some(c=>c.dataset.group===key))this.controls.group.add(new Option(group.querySelector('h2').firstChild.textContent.trim(),key));
   });
   this.cards.forEach(c=>this.groups.find(g=>g.dataset.stockGroup===c.dataset.group).querySelector('.psv-grid').append(c));
  }
  restore(){const p=new URL(location.href).searchParams;Object.entries(this.controls).forEach(([key,el])=>el.value=p.get('stock_'+key)||(key==='sort'?'featured':''))}
  save(){const url=new URL(location.href);Object.entries(this.controls).forEach(([key,el])=>{if(el.value&&el.value!=='featured')url.searchParams.set('stock_'+key,el.value);else url.searchParams.delete('stock_'+key)});history.replaceState(null,'',url)}
  update(){
   const group=this.controls.group.value,colour=this.controls.colour.value,budget=this.controls.budget.value,sort=this.controls.sort.value;
   let total=0;const jumps=this.querySelector('.psv-jumps');jumps.replaceChildren();
   this.cards.forEach(card=>{card.hidden=!!((group&&card.dataset.group!==group)||(colour&&card.dataset.colour!==colour)||(budget!==''&&Number(card.dataset.price)>Number(budget)*100));if(!card.hidden)total++});
   this.groups.forEach(section=>{
    const cards=this.cards.filter(c=>c.dataset.group===section.dataset.stockGroup);
    cards.sort((a,b)=>sort==='price-ascending'?Number(a.dataset.price)-Number(b.dataset.price):sort==='price-descending'?Number(b.dataset.price)-Number(a.dataset.price):a.dataset.title.localeCompare(b.dataset.title)||a.dataset.colour.localeCompare(b.dataset.colour));
    cards.forEach(c=>section.querySelector('.psv-grid').append(c));
    const count=cards.filter(c=>!c.hidden).length;section.hidden=count===0;section.querySelector('.psv-group-count').textContent=count;
    if(count){const link=document.createElement('a');link.href='#'+section.id;link.textContent=section.querySelector('h2').firstChild.textContent.trim();jumps.append(link)}
   });
   this.status.textContent=total+' '+this.dataset.countLabel+(this.complete?'':' · '+this.dataset.loadingLabel);
   this.querySelector('.psv-empty').hidden=total>0||!this.complete;
  }
  async loadRemaining(){
   let next=this.dataset.next;this.abort=new AbortController();const visited=new Set();
   try{while(next){
    const url=new URL(next,location.href);url.searchParams.set('section_id',this.dataset.section);
    if(visited.has(url.href))throw new Error('Repeated page');visited.add(url.href);
    const response=await fetch(url,{signal:this.abort.signal});if(!response.ok)throw new Error('Unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');const root=doc.querySelector('pretty-stock-variants');if(!root)throw new Error('Unavailable');
    const ids=new Set(this.cards.map(c=>c.dataset.variant));root.querySelectorAll('.psv-card').forEach(c=>{if(!ids.has(c.dataset.variant))this.cards.push(c)});
    const selected=this.controls.group.value;this.rebuild();this.controls.group.value=selected;
    next=root.dataset.next;this.complete=!next;this.update();
   }this.querySelector('.psv-next')?.remove()}
   catch(error){if(error.name!=='AbortError')this.status.textContent=this.dataset.errorLabel}
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
